/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The kind of a reply.
 */
export const CommentType = /* #__PURE__ */ parsers.exactly('normal', 'peer_feedback');
